import SelectorEngine from '../../../utils/dom/selector-engine';
import EventHandler from '../../../utils/dom/event-handler';

const CLICK_EVENT = 'click';
const WRAPPER_SELECTOR = '.p-venue-registeration-landing-multisite-with-venue';
const TRIGGER_SELECTOR = '.js-insurance-locked-trigger';
const MODAL_SELECTOR = '#insurance-locked-modal';

/**
 * Opens the "This section is currently locked" overlay modal when the
 * locked Insurance spotlight-card is clicked, instead of navigating away.
 */
class InsuranceLockedModal {
	constructor() {
		this._wrapper = SelectorEngine.findOne(WRAPPER_SELECTOR);
		if (!this._wrapper) {
			return;
		}

		this.modal = SelectorEngine.findOne(MODAL_SELECTOR, this._wrapper);
		if (!this.modal) {
			return;
		}

		EventHandler.on(this._wrapper, CLICK_EVENT, TRIGGER_SELECTOR, (event) => {
			event.preventDefault();
			this.modal.isOpen = true;
		});
	}

	static boot() {
		const start = () => requestAnimationFrame(() => new InsuranceLockedModal());

		if (customElements.get('lta-overlay-modal')) {
			start();
		} else {
			customElements
				.whenDefined('lta-overlay-modal')
				.then(start)
				.catch(() => {});
		}
	}
}

InsuranceLockedModal.boot();

export default InsuranceLockedModal;
